import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import axios from '../../../../utils/fvAxios';
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

function Instructions() {

    const [Info, setInfo] = useState([]);
    const [spinner, setSpinner] = useState(false);

    useEffect(() => {
        setSpinner(true);
        axios
            .get("AdminVendors/GetCourseInstructions")
            .then((res) => {
                setInfo(res?.data?.data);
                setSpinner(false);
            })
            .catch((err) => {
                console.log(err);
                setSpinner(false);
            });

    }, []);

    return (
        <>
            <style> {`.instruction-html p { margin-bottom: 0;}`}</style>
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={spinner}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Box sx={{ width: '100%', padding: "10px", overflowX: "hidden" }}>
                {Info?.description == null && Info?.Title == null ? (
                    <Box hidden={spinner} border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec" sx={{ padding: 2, marginTop: 4, marginRight: "12px", width: "auto" }} className="text-center">
                        <span style={{ color: "#667085" }}>No instructions</span>
                    </Box>
                ) : (<>
                    <p hidden={spinner} style={{ fontSize: "28px", color: "#101828", fontWeight: "600", marginBottom: "3px" }}>{Info?.title}</p>

                    <Box hidden={spinner} border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec" sx={{ padding: 2, marginRight: "12px", width: "auto" }} >
                        <div className="instruction-html" dangerouslySetInnerHTML={{ __html: Info?.description }} ></div>
                    </Box>

                </>
                )}
            </Box >
        </>
    )
}

export default Instructions